// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from '../../../../../node_module_clones/react-router';

// Utils
import platformSingleton from '../../../../platform/platformSingleton';
import { isSubscribed } from '../../../../user/userUtil';
import { getDisplayName, getEmail } from '../../../../../common/users/userHelper';
import { isPlatformPhoneOrMobileMode } from '../../../../platform/utils/platformDetailsUtils';

// Components
import LinkButton from '../../../../components/buttons/LinkButton';
import PopupPanel from '../../../../components/popupPanel/PopupPanel';

import AvatarPickerContainer from './avatar/AvatarPickerContainer';
import BillingTierFree from './billingStatus/BillingTierFree';
import BillingTierPro from './billingStatus/BillingTierPro';
import UserPlanBadge from '../../../../components/userAvatar/UserPlanBadge';
import PopupPanelAsideSection from '../../../../components/popupPanel/types/asideSection/PopupPanelAsideSection';
import PopupActionsSection from '../../../../components/popupPanel/types/actionsSection/PopupActionsSection';
import { LoadableAccountModalRoot } from '../../../../user/account/accountModal/LoadableAccountModalComponents';

import MobileSwitchCanvasView from './MobileSwitchCanvasView';
import VersionBanner from './VersionBanner';

// Actions
import * as authActions from '../../../../auth/authActions';

// Constants
import { PopupIds } from '../../../../components/popupPanel/popupConstants';

// Styles
import './AccountPopup.scss';

const mapDispatchToProps = (dispatch) => ({
    logout: () => dispatch(authActions.logout()),
});

/**
 * Note: The mobile counterpart for this component is AccountProfileMobile
 */
let AccountUserPopup = (props) => {
    const { currentUser, logout } = props;

    React.useEffect(() => {
        LoadableAccountModalRoot.preload();
    }, []);

    return (
        <React.Fragment>
            <PopupPanelAsideSection className="profile" asideChildren={<AvatarPickerContainer user={currentUser} />}>
                <div className="user-name">
                    <h3 className="name">{getDisplayName(currentUser)}</h3>
                    <UserPlanBadge user={currentUser} />
                </div>
                <div className="email">{getEmail(currentUser)}</div>

                <PopupActionsSection>
                    <Link className="settings-button" to="/account/settings">
                        Account settings
                    </Link>
                    <LinkButton onClickFn={logout}>Log out</LinkButton>
                </PopupActionsSection>
            </PopupPanelAsideSection>

            {isSubscribed(currentUser) ? (
                <BillingTierPro {...props} />
            ) : (
                <BillingTierFree shouldFetchCounts {...props} />
            )}

            <VersionBanner {...props} />

            {isPlatformPhoneOrMobileMode(platformSingleton) && <MobileSwitchCanvasView {...props} />}
        </React.Fragment>
    );
};

AccountUserPopup.propTypes = {
    currentUser: PropTypes.object.isRequired,
    logout: PropTypes.func,
};

AccountUserPopup = connect(null, mapDispatchToProps)(AccountUserPopup);

const AccountPopup = (props) => (
    <PopupPanel {...props} className="AccountPopup" popupId={PopupIds.USER}>
        <AccountUserPopup {...props} />
    </PopupPanel>
);

export default AccountPopup;
